export default __webpack_public_path__ + "static/media/no_img_placeholder.e9f3eb05.png";